import { ComponentPropsWithoutRef, forwardRef, ReactNode, RefObject } from 'react';

import { cx } from '@libs/classnames';

import styles from './FancyPanel.module.css';

export type FancyPanelProps = ComponentPropsWithoutRef<'div'> & {
  panelRef?: RefObject<HTMLDivElement | null>;
  controls?: ReactNode;
  actions?: ReactNode;
  subActions?: ReactNode;
  panelClassName?: string;
  contentClassName?: string;
};

export const FancyPanel = forwardRef<HTMLDivElement, FancyPanelProps>(({
  panelRef,
  controls,
  actions,
  subActions,
  className,
  panelClassName,
  contentClassName,
  children,
  ...rest
}, ref) => {
  return (
    <div ref={ref} className={cx(styles.root, className)} {...rest}>
      <div ref={panelRef} className={cx(styles.panel, panelClassName)} />
      <div className={styles.contentWrap}>
        <div className={cx(styles.content, contentClassName)}>{children}</div>
        {actions && <div className={styles.actions}>{actions}</div>}
      </div>
      {controls && <div className={styles.controls}>{controls}</div>}
      {subActions && <div className={styles.subActions}>{subActions}</div>}
    </div>
  );
});
